<template>
    <div class="apprentice-simple-card">
        <div class="row">
            <div class="col-12 col-md-4 col-xxl-3">
                <design-2021-faq-category-nav-component :categories-in="categories"
                                                        :selected-category-in="selectedNavCategory"
                                                        @update-selected-category="updateSelectedCategory">
                </design-2021-faq-category-nav-component>
            </div>

            <div class="col-12 col-md-8 col-xxl-9">
                <div class="apprentice-search-bar faq-search-bar">
                    <b-input-group>
                        <b-form-input size="md"
                                      placeholder="Zoeken"
                                      v-model="searchTerm">
                        </b-form-input>
                        <b-input-group-append>
                            <div class="icon">
                                <i class="fas fa-search fa-fw"></i>
                            </div>
                        </b-input-group-append>
                    </b-input-group>
                </div>

                <div class="faqs" v-if="faqQuestions.length > 0">
                    <design-2021-faq-category-question-answer-component :question-in="question"
                                                                        v-for="question in faqQuestions"
                                                                        :key="question.id">
                    </design-2021-faq-category-question-answer-component>
                </div>

                <div class="not-found with-header empty-paper-or-assignment-list" v-else>
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice assignments">{{$t('faq.no_questions_found')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "design-2021-faq-component",
    props:{
        faqsIn: {
            type: Array,
            required: true,
        }
    },

    data() {
        return {
            searchTerm: '',
            selectedNavCategory: this.faqsIn.length ? this.faqsIn[0].id : null,
        }
    },

    computed: {
        categories() {
            if(!this.faqsIn.length) {
                return [];
            }

            return this.faqsIn.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    student: category.student,
                    teacher: category.teacher,
                }
            });
        },

        faqQuestions() {
            if(this.searchTerm.length <= 3){
                if(this.selectedNavCategory === null && this.categories.length){
                    this.selectedNavCategory = this.categories[0].id;
                }

                for(const category of this.faqsIn){
                    if(category.id === this.selectedNavCategory){
                        if(!this.$authUser.isStudent()) {
                            return category.afaq_question_answers;
                        } else {
                            return category.afaq_question_answers.filter(question_answers => question_answers.student);
                        }
                    }
                }
            } else {
                let questions = [];
                const filtertedQuestions =  this.faqsIn
                    .map((faqCategory) => {
                        let filteredFaqs = [];
                        const lowerCasedTerm = this.searchTerm.toLowerCase();

                        for (const faqQuestionAnswer of faqCategory.afaq_question_answers) {
                            let found = false;

                            if (faqQuestionAnswer.afaq_tags.find(tags => tags.name.toLowerCase() === lowerCasedTerm)) {
                                found = true;
                            }

                            if (faqQuestionAnswer.question.toLowerCase().indexOf(lowerCasedTerm) !== -1) {
                                found = true;
                            }

                            if (faqQuestionAnswer.answer.toLowerCase().indexOf(lowerCasedTerm) !== -1) {
                                found = true;
                            }

                            if (found) {
                                filteredFaqs.push(faqQuestionAnswer);
                            }
                        }

                        return {
                            name: faqCategory.name,
                            id: faqCategory.id,
                            question_answers: filteredFaqs,
                            student: faqCategory.student,
                            teacher: faqCategory.teacher,
                        };
                });

                if(filtertedQuestions.length) {
                    for (const category of filtertedQuestions) {
                        if (!category.question_answers.length) {
                            continue;
                        }

                        questions.push(...category.question_answers);
                    }
                }

                if(!this.$authUser.isStudent()) {
                    return [...questions];
                } else {
                    questions = [...questions];
                    return questions.filter(question_answers => question_answers.student);
                }
            }
        },
    },

    methods: {
        updateSelectedCategory(category) {
            this.selectedNavCategory = category.id;
        },
    }
}
</script>

<style scoped lang="scss">
    .faq-search-bar {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }

    @media(min-width: map-get($grid-breakpoints, 'md')){
        .faq-search-bar {
            margin-bottom: 0;
            width: 400px;
        }
    }
</style>
